import React from 'react'
import { Grid } from '@mui/material'
import GroupingExportsTable from 'Pages/ReportsAlerts/ExportsGrouping/Table'
import DateRangeFilter from 'Pages/ReportsAlerts/ExportsGrouping/Filter'
import GroupingExportsModal from 'Pages/ReportsAlerts/ExportsGrouping/Modal'


export default function GroupingExportsContent() {

	return <Grid container spacing={2}>
		<Grid item xs={2}>
			<DateRangeFilter/>
		</Grid>
		<Grid item xs={12}>
			<GroupingExportsTable/>
		</Grid>
		<Grid item xs={12}>
			<GroupingExportsModal/>
		</Grid>
	</Grid>
}